import APIService from "./APIService";

/**
 * Service for handling Phone Number Scam Check API operations
 *
 * Expected response format:
 * {
 *   "success": true/false,
 *   "message": "Descriptive message",
 *   "data": { ... }
 * }
 */
const PhoneNumberScamCheckAPI = {
  /**
   * Analyze phone number for scam detection and risk assessment
   * @param {string} phoneNumber - Phone number to analyze (digits only)
   * @param {string} userContext - Optional user-provided context
   * @returns {Promise} Promise that resolves with analysis result
   */
  analyzePhoneNumber: async (phoneNumber, userContext) => {
    try {
      console.log(
        "[PhoneNumberScamCheckAPI] Analyzing phone number:",
        phoneNumber,
      );
      const body = { phoneNumber };
      if (userContext && userContext.trim()) {
        body.userContext = userContext.trim();
      }
      const response = await APIService.post(
        "/api/v1/scam/analysis/phone-number-scam-check",
        body,
      );
      console.log("[PhoneNumberScamCheckAPI] Analysis response:", response);
      return response;
    } catch (error) {
      console.error(
        "[PhoneNumberScamCheckAPI] Error analyzing phone number:",
        error,
      );
      throw error;
    }
  },
};

export default PhoneNumberScamCheckAPI;
